import { useMutation } from '@apollo/client'
import { useRouter } from 'next/router'
import { format } from 'url'

import { useBannerActions } from 'src/components/banner-callout/use-banner-actions'

import { OPEN_DIRECT_THREAD } from 'src/graphql/message-thread'

export const useOpenDirectThread = (userId: string, networkName: string) => {
  const { setBanner } = useBannerActions()
  const [openDirectThreadMutation] = useMutation(OPEN_DIRECT_THREAD)
  const router = useRouter()

  const navigateToThread = (threadId: string) => {
    const pathname = `/n/${router.query.network}/user/${userId}/messages`
    const query = { thread: threadId }
    const url = format({ pathname, query })
    router.push(url)
  }

  const openDirectThread = async (): Promise<boolean> => {
    if (!userId) return false
    try {
      const res = await openDirectThreadMutation({
        variables: { userId, networkName }
      })
      const threadId = res.data?.openDirectThread.id
      if (threadId) {
        navigateToThread(threadId)
      }
      return true
    } catch (_) {
      setBanner({
        message:
          'We were unable to add this conversation. Please try again in a few minutes.',
        calloutType: 'error'
      })
      return false
    }
  }

  return { openDirectThread }
}
